import React from "react";
import { Container, Box } from "@mui/material";
import PotionBackground from "./PotionBackground";
import PotionFooter from "./PotionFooter";

export default function PotionLayout({ children, width }) {
  return (
    <>
      <PotionBackground />
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <Container
          sx={{
            width: width || "84%",
            margin: 0,
            padding: 0,
          }}
        >
          {children}
        </Container>
        <PotionFooter />
      </Box>
    </>
  );
}
